module.exports = __webpack_public_path__ + "static/MVP & Prototyping-0e48bc7f11231bcc40e543b247d38d66.png";